import { render } from "./Cost.vue?vue&type=template&id=6e7f2df6"
import script from "./Cost.vue?vue&type=script&lang=js"
export * from "./Cost.vue?vue&type=script&lang=js"
script.render = render

export default script